export default __webpack_public_path__ + "static/media/lock_icon.4d7c2e33.svg";